import React, { createContext, useContext, useEffect, useState } from 'react';
import hoaApi from '@/utils/hoaApi';

const HoaAuthContext = createContext(null);

export const HoaAuthProvider = ({ children }) => {
  // null = checking | false = unauthenticated | object = homeowner
  const [homeowner, setHomeowner] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('hoa_token');
    const stored = localStorage.getItem('hoa_homeowner');
    if (token && stored) {
      // Verify the token is still valid against the server
      hoaApi.get('/hoa/me/profile')
        .then(({ data }) => {
          setHomeowner(data);
          localStorage.setItem('hoa_homeowner', JSON.stringify(data));
        })
        .catch(() => {
          localStorage.removeItem('hoa_token');
          localStorage.removeItem('hoa_homeowner');
          setHomeowner(false);
        });
    } else {
      setHomeowner(false);
    }
  }, []);

  const signIn = (token, homeownerPayload) => {
    localStorage.setItem('hoa_token', token);
    localStorage.setItem('hoa_homeowner', JSON.stringify(homeownerPayload));
    setHomeowner(homeownerPayload);
  };

  const signOut = () => {
    localStorage.removeItem('hoa_token');
    localStorage.removeItem('hoa_homeowner');
    setHomeowner(false);
  };

  return (
    <HoaAuthContext.Provider value={{ homeowner, signIn, signOut }}>
      {children}
    </HoaAuthContext.Provider>
  );
};

export const useHoaAuth = () => {
  const ctx = useContext(HoaAuthContext);
  if (!ctx) throw new Error('useHoaAuth must be used within a HoaAuthProvider');
  return ctx;
};
